/**
 * Модель для работы с отчётом "Использование СИЗ"
 */

import { createModel } from '@rematch/core';
import { RootModel } from './index';
import { saveAs } from 'file-saver';

import { IEmployeeShort, IReportUseProtection } from './types';
import setStartEndOfDay from '../utils/setStartEndOfDay';

import UsersService from '../services/UsersService';
import ReportService from '../services/ReportService';

interface IData {
  employees: IEmployeeShort[];
}

interface IList {
  data: IReportUseProtection[] | null;
  pagesCount: number;
}

interface IState {
  data: IData;
  list: IList;
}

const initialState: IState = {
  data: {
    employees: []
  },
  list: {
    data: null,
    pagesCount: 0
  }
};

export const reportUseProtection = createModel<RootModel>()({
  state: initialState,
  reducers: {
    setData(state: IState, payload: IData): IState {
      return { ...state, data: payload };
    },
    setList(state: IState, payload: IList): IState {
      return { ...state, list: payload };
    },
    resetList(state: IState): IState {
      return {
        ...state,
        list: {
          data: null,
          pagesCount: 0
        }
      };
    },
    reset(): IState {
      return { ...initialState };
    }
  },
  effects: () => ({
    async getData() {
      try {
        const [{ data: employees }] = await Promise.all([UsersService.getAllEmployeesShort()]);

        this.setData({ employees });
      } catch (error) {
        return error;
      }
    },
    async getList(params: any, rootState?: any) {
      const cloneParams = setStartEndOfDay(params, ['from', 'to']);

      try {
        const { data } = await ReportService.getUseProtection(cloneParams);

        this.setList(data);
      } catch (error) {
        return error;
      }
    },
    async exportList(params: any, rootState?: any) {
      const { from, to } = params;

      const cloneFilter = setStartEndOfDay(params, ['from', 'to']);

      try {
        const { data } = await ReportService.getCsvUseProtection(cloneFilter);

        saveAs(data, `Отчет по использованию СИЗ за период ${from} - ${to}.csv`);
      } catch (error) {
        return error;
      }
    }
  })
});
